<template>
  <b-row class="pb-5">
    <!-- TOP CLIENTES -->
    <b-col cols="6">
      <card class="no-border-card db-list-card h-100" body-classes="px-3 pb-1">
        <div class="px-3 py-3 text-center">
          <h2 class="db-list-title">Top Clientes</h2>
        </div>

        <b-list-group
          v-if="topClientes && topClientes.length"
          flush
          class="list my--3 py-3"
        >
          <b-list-group-item
            v-for="(cliente, index) in visibleTopClientes"
            :key="index"
            class="px-0 db-list-item"
          >
            <b-row>
              <b-col md="auto"></b-col>
              <b-col>
                <h5
                  class="db-list-name pointer"
                  @click="$emit('ver-perfil', cliente.qr_code)"
                >
                  {{ cliente.nome }}
                  <span class="db-list-pct"
                    >{{ cliente.percent_consumo }}%</span
                  >
                </h5>
                <base-progress
                  class="progress-xs mb-0"
                  type="orange"
                  :value="Number(cliente.percent_consumo) || 0"
                />
                <span class="db-list-meta">
                  {{ cliente.visitas }} visitas |
                  {{ formatarEuro(cliente.total_pago) }}
                </span>
              </b-col>
            </b-row>
          </b-list-group-item>
        </b-list-group>

        <div v-else class="text-center text-muted py-5">
          <em>Sem dados a mostrar</em>
        </div>

        <b-row
          align-v="center"
          class="text-center"
          v-if="topClientes && topClientes.length"
        >
          <b-col cols="6" class="text-left">
            <i
              v-if="pageClientes > 0"
              class="ni ni-bold-left pointer mx-2 db-pag-arrow"
              @click="pageClientes--"
            ></i>
          </b-col>
          <b-col cols="6" class="text-right">
            <i
              v-if="(pageClientes + 1) * pageSize < topClientes.length"
              class="ni ni-bold-right pointer mx-2 db-pag-arrow"
              @click="pageClientes++"
            ></i>
          </b-col>
        </b-row>
      </card>
    </b-col>

    <!-- TOP RESTAURANTES -->
    <b-col cols="6">
      <card class="no-border-card db-list-card h-100" body-classes="px-3 pb-1">
        <div class="px-3 py-3 text-center">
          <h2 class="db-list-title">Top Restaurantes</h2>
        </div>

        <b-list-group
          v-if="topRestaurantes && topRestaurantes.length"
          flush
          class="list my--3 py-3"
        >
          <b-list-group-item
            v-for="(rest, index) in visibleTopRestaurantes"
            :key="index"
            class="px-0 db-list-item"
          >
            <b-row>
              <b-col md="auto"></b-col>
              <b-col>
                <h5 class="db-list-name">
                  {{ rest.nome }}
                  <span class="db-list-pct"
                    >{{ rest.percent_consumo }}% da faturação</span
                  >
                </h5>
                <base-progress
                  class="progress-xs mb-0"
                  type="orange"
                  :value="Number(rest.percent_consumo) || 0"
                />
                <span class="db-list-meta">
                  {{ rest.visitas }} refeições |
                  {{ formatarEuro(rest.total_pago) }}
                </span>
              </b-col>
            </b-row>
          </b-list-group-item>
        </b-list-group>

        <div v-else class="text-center text-muted py-5">
          <em>Sem dados a mostrar</em>
        </div>

        <b-row
          align-v="center"
          class="text-center"
          v-if="topRestaurantes && topRestaurantes.length"
        >
          <b-col cols="6" class="text-left">
            <i
              v-if="pageRestaurantes > 0"
              class="ni ni-bold-left pointer mx-2 db-pag-arrow"
              @click="pageRestaurantes--"
            ></i>
          </b-col>
          <b-col cols="6" class="text-right">
            <i
              v-if="(pageRestaurantes + 1) * pageSize < topRestaurantes.length"
              class="ni ni-bold-right pointer mx-2 db-pag-arrow"
              @click="pageRestaurantes++"
            ></i>
          </b-col>
        </b-row>
      </card>
    </b-col>
  </b-row>
</template>

<script>
  import BaseProgress from "@/components/BaseProgress";

  export default {
    name: "DashboardTopListas",
    components: { BaseProgress },
    props: {
      topClientes: { type: Array, default: () => [] },
      topRestaurantes: { type: Array, default: () => [] },
    },
    data() {
      return {
        pageClientes: 0,
        pageRestaurantes: 0,
        pageSize: 5,
      };
    },
    computed: {
      visibleTopClientes() {
        const start = this.pageClientes * this.pageSize;
        return (this.topClientes || []).slice(start, start + this.pageSize);
      },
      visibleTopRestaurantes() {
        const start = this.pageRestaurantes * this.pageSize;
        return (this.topRestaurantes || []).slice(start, start + this.pageSize);
      },
    },
    methods: {
      formatarEuro(valor) {
        return new Intl.NumberFormat("fr-FR", {
          style: "currency",
          currency: "EUR",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(valor);
      },
    },
  };
</script>
